export default __webpack_public_path__ + "static/media/eye.8563ae29.svg";